import React, { useState, useEffect, useRef } from 'react';
import introJs from 'intro.js';
import 'intro.js/introjs.css';

// 1. DEFINICIÓN DE ESTILOS PREMIUM (Blindados y restaurados v17)
const TOUR_STYLES = `
  /* ESTILOS DEL MODAL DE BIENVENIDA ORIGINAL */
  .welcome-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.75);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000000;
    animation: tourFadeIn 0.3s ease-out;
  }
  @keyframes tourFadeIn { from { opacity: 0; } to { opacity: 1; } }

  .welcome-modal-card {
    background: white;
    width: 90%;
    max-width: 500px;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 25px 50px rgba(0,0,0,0.5);
    animation: tourSlideUp 0.5s cubic-bezier(0.19, 1, 0.22, 1);
  }
  @keyframes tourSlideUp { from { transform: translateY(60px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

  .welcome-modal-header {
    background: #003366;
    color: white;
    padding: 30px;
    text-align: center;
    border-bottom: 4px solid #ffc107;
  }
  .welcome-modal-header h2 { margin: 0; font-size: 1.6rem; font-weight: 700; color: white !important; }

  .welcome-modal-body {
    padding: 35px;
    color: #333;
    line-height: 1.6;
    font-size: 1.15rem;
    text-align: center;
  }

  .welcome-modal-footer {
    padding: 10px 35px 40px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .btn-start-tour {
    background: #003366;
    color: white;
    border: none;
    padding: 16px;
    border-radius: 10px;
    font-weight: bold;
    cursor: pointer;
    font-size: 1.1rem;
    transition: all 0.2s;
    box-shadow: 0 4px 12px rgba(0,51,102,0.3);
  }
  .btn-start-tour:hover { background: #004a94; transform: translateY(-2px); color: white; }

  .btn-skip-tour {
    background: transparent;
    color: #666;
    border: 2px solid #eee;
    padding: 14px;
    border-radius: 10px;
    font-weight: 500;
    cursor: pointer;
    font-size: 1rem;
    transition: all 0.2s;
  }
  .btn-skip-tour:hover { background: #f8f9fa; border-color: #ddd; color: #333; }

  /* ESTILOS DE LOS TOOLTIPS DEL RECORRIDO */
  .custom-tooltip-style {
    max-width: 380px !important;
    width: 380px !important;
    border-radius: 15px !important;
    padding: 20px !important;
    box-shadow: 0 15px 40px rgba(0,0,0,0.2) !important;
    border: none !important;
    background: white !important;
  }

  .introjs-tooltip-title {
    font-family: 'Outfit', sans-serif !important;
    font-weight: 700 !important;
    font-size: 1.3rem !important;
    margin-bottom: 15px !important;
    display: block !important;
    color: #003366 !important;
  }

  .introjs-tooltiptext {
    font-family: 'Inter', sans-serif !important;
    font-size: 1rem !important;
    line-height: 1.6 !important;
    color: #444 !important;
  }

  .introjs-button {
    border-radius: 8px !important;
    padding: 10px 20px !important;
    font-weight: 600 !important;
    transition: all 0.2s ease !important;
    text-shadow: none !important;
    box-shadow: none !important;
  }

  .introjs-nextbutton {
    background: #003366 !important;
    color: white !important;
    border: none !important;
  }

  .introjs-prevbutton {
    background: #f0f0f0 !important;
    color: #666 !important;
    border: 1px solid #ddd !important;
  }

  .introjs-bullets ul li a.active {
    background: #003366 !important;
  }

  .introjs-progress {
    height: 6px !important;
    background-color: #eee !important;
  }

  .introjs-progressbar {
    background-color: #007bff !important;
  }

  .introjs-skipbutton {
    display: block !important;
    color: #999 !important;
    font-size: 22px !important;
    font-weight: bold !important;
    text-decoration: none !important;
    position: absolute !important;
    top: 5px !important;
    right: 12px !important;
    cursor: pointer !important;
    line-height: 1 !important;
  }
  .introjs-skipbutton:hover {
    color: #d9534f !important;
  }

  /* Asegurar que el elemento resaltado sea clicable */
  .introjs-showElement {
    z-index: 10000001 !important;
    position: relative !important;
    pointer-events: auto !important;
    opacity: 1 !important;
    filter: none !important;
  }

  /* FIX GRISADO: el elemento resaltado y TODOS sus hijos deben verse con color normal */
  .introjs-showElement,
  .introjs-showElement * {
    opacity: 1 !important;
    filter: none !important;
    color: inherit !important;
  }

  /* BLINDAJE DEFINITIVO PARA MENÚS DESPLEGABLES DE REACT-SELECT */
  .select__menu,
  .select__menu-list,
  .select__option,
  [class*="select__menu"] {
    background-color: white !important;
    opacity: 1 !important;
    filter: none !important;
    z-index: 2147483647 !important;
    color: #333 !important;
  }
  
  .select__option--is-focused,
  .select__option:hover {
    background-color: #e6f2ff !important;
  }
  
  .select__option--is-selected {
    background-color: #003366 !important;
    color: white !important;
  }

  /* Evitar que las capas de ayuda de intro.js bloqueen los clics internos */
  .introjs-helperLayer, .introjs-tooltipReferenceLayer {
    pointer-events: none !important;
  }

  .introjs-overlay, .introjs-disableInteraction {
    pointer-events: none !important;
  }

  /* FIX: Eliminar el stacking context de contenedores problemáticos */
  body.ifop-tour-active .z-2,
  body.ifop-tour-active .overlay,
  body.ifop-tour-active .position-relative,
  body.ifop-tour-active .margin_main,
  body.ifop-tour-active .card,
  body.ifop-tour-active .custom-card,
  body.ifop-tour-active .card-body,
  body.ifop-tour-active .row,
  body.ifop-tour-active [class*="col-"],
  body.ifop-tour-active header,
  body.ifop-tour-active main,
  body.ifop-tour-active #acuicultura-v1-root,
  body.ifop-tour-active .fondo-gris,
  body.ifop-tour-active .buscador-avanzado {
    z-index: auto !important;
    transform: none !important;
    opacity: 1 !important;
    filter: none !important;
    isolation: auto !important;
  }



  /* FIX: Tooltip posicionado a la derecha para pasos de resultados/filtros */
  .step-right-forced .introjs-tooltip {
    left: auto !important;
    right: 20px !important;
    position: fixed !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
  }

  .introjs-tooltip {
    pointer-events: auto !important;
  }

  /* CLASE PARA FORZAR POSICIÓN IZQUIERDA EN PANTALLAS PEQUEÑAS (Laptops 14") */
  .step-left-forced.introjs-tooltip {
    max-width: 320px !important;
    width: 320px !important;
    margin-right: 15px !important;
  }

  @media (max-width: 1400px) {
    .step-left-forced.introjs-tooltip {
      max-width: 280px !important;
      width: 280px !important;
      margin-left: -50px !important; /* Ajuste para notebooks */
    }
  }

  /* MEJORAS RESPONSIVAS PARA MÓVILES (v31 - Ultra Compacto) */
  @media (max-width: 768px) {
    .custom-tooltip-style {
      width: calc(100vw - 50px) !important;
      max-width: 280px !important; /* Limitar ancho máximo para evitar que se vea gigante */
      min-width: auto !important;
      left: 50% !important;
      transform: translateX(-50%) !important;
      margin: 5px 0 !important;
      padding: 8px 12px !important;
      height: auto !important;
      min-height: auto !important;
    }

    .introjs-tooltip-title { 
      font-size: 0.9rem !important; 
      margin-bottom: 3px !important;
      padding-top: 2px !important;
    }
    
    .introjs-tooltiptext { 
      font-size: 0.8rem !important; 
      line-height: 1.2 !important;
      padding: 2px 0 !important;
    }

    /* Reducir tamaño del mensaje de validación */
    .tour-validation-msg {
      font-size: 0.75rem !important;
      margin-top: 4px !important;
    }

    .introjs-tooltipReferenceLayer {
      width: 100% !important;
      left: 0 !important;
    }

    .introjs-helperLayer {
      box-shadow: 0 0 0 1000vh rgba(0,0,0,0.3) !important;
      border: 2px solid #ffc107 !important;
    }

    .introjs-tooltipbuttons {
      padding: 4px !important;
      margin-top: 4px !important;
    }
    
    .introjs-button {
      padding: 3px 8px !important;
      font-size: 0.75rem !important;
    }

    .introjs-bullets {
      display: none !important; /* Ocultar bullets en móvil para ahorrar espacio vertical */
    }
  }
`;

const TourBuscador = ({ enabled: enabledProp, onExit, title = "¡Bienvenido al Buscador de Datos Pesqueros!" }) => {
  const [showWelcome, setShowWelcome] = useState(false);
  const isStartedRef = useRef(false);
  const tourRef = useRef(null);

  // A. INYECCIÓN DE ESTILOS BLINDADOS v30 (Control de Caché Forzado)
  useEffect(() => {
    const styleId = 'ifop-tour-buscador-pesqueria-v41';
    // Limpiar cualquier residuo de versiones anteriores
    const oldStyles = document.querySelectorAll('[id^="ifop-tour-styles-"]');
    oldStyles.forEach(el => {
      if (el.id !== styleId) el.remove();
    });

    if (!document.getElementById(styleId)) {
      const styleEl = document.createElement('style');
      styleEl.id = styleId;
      styleEl.innerHTML = TOUR_STYLES;
      document.head.appendChild(styleEl);
    }
  }, []);

  // B. LIMPIEZA DE RESIDUOS
  const cleanTourGarbage = () => {
    document.body.classList.remove('introjs-showElement', 'introjs-relativeElement', 'introjs-fixParent', 'ifop-tour-active');
    const garbage = document.querySelectorAll('.introjs-overlay, .introjs-helperLayer, .introjs-tooltipReferenceLayer, .introjs-hints');
    garbage.forEach(el => el.remove());
  };

  // C. CONTROL DE PERSISTENCIA (v17)
  useEffect(() => {
    // Clave de versión para control de caché (v24 - Restauración de Cierre)
    const hasSeenTour = localStorage.getItem('ifop_tour_v24');

    if (enabledProp) {
      cleanTourGarbage();
      introJs().exit(true);
      startTour();
    } else if (!hasSeenTour) {
      const timer = setTimeout(() => {
        setShowWelcome(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [enabledProp]);

  // D. LOGICA DE INICIO
  const startTour = () => {
    if (isStartedRef.current) return;
    setShowWelcome(false);
    cleanTourGarbage();
    introJs().exit(true);

    document.body.classList.add('ifop-tour-active');

    const tour = introJs();
    tourRef.current = tour;

    tour.setOptions({
      nextLabel: 'Siguiente',
      prevLabel: 'Anterior',
      doneLabel: 'Finalizar',
      showSkipButton: true,
      skipLabel: '×',
      hidePrev: true,
      showProgress: true,
      showBullets: true,
      exitOnOverlayClick: false,
      scrollToElement: true,
      scrollPadding: window.innerWidth < 768 ? 200 : 100,
      tooltipClass: 'custom-tooltip-style',
      disableInteraction: false,
      steps: [
        {
          element: '#tour-multi-select',
          intro: '<b style="color: #003366; font-size: 1.1rem;">1. Filtro Principal</b><br/><br/>Selecciona aquí la especie o proyecto que deseas consultar.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Se requiere agregar la selección para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'right',
        },
        {
          element: '#tour-anio-desde',
          intro: '<b style="color: #003366; font-size: 1.1rem;">2. Año Inicio</b><br/><br/>Define el primer año del rango.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Se requiere agregar la selección para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'left',
        },
        {
          element: '#tour-anio-hasta',
          intro: '<b style="color: #003366; font-size: 1.1rem;">3. Año Término</b><br/><br/>Define el último año del rango.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Se requiere agregar la selección para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'left',
        },
        {
          element: '#tour-btn-buscar',
          intro: '<b style="color: #d9534f; font-size: 1.1rem;">4. ¡Pulsa Buscar!</b><br/><br/>Haz clic aquí para cargar los resultados.<br/><br/><i class="tour-validation-msg" style="color: #ff0000; font-size: 0.85rem; display: none;">* Por favor, presiona el botón Buscar para continuar.</i>',
          position: window.innerWidth < 768 ? 'top' : 'left',
        },
        {
          element: '#tour-filtros-laterales',
          intro: '<b style="color: #003366; font-size: 1.1rem;">5. Filtros Secundarios</b><br/><br/>Aquí puedes refinar por especies, regiones o puertos.',
          position: window.innerWidth < 768 ? 'top' : 'right',
          disableInteraction: false,
        },
        {
          element: '#tour-resultados-container',
          intro: '<b style="color: #003366; font-size: 1.1rem;">6. Tabla de Resultados</b><br/><br/>Visualiza toda la información filtrada aquí.',
          position: window.innerWidth < 768 ? 'top' : 'left',
          tooltipClass: 'custom-tooltip-style step-left-forced',
          disableInteraction: false,
        },
        {
          element: '#tour-resultados-container',
          intro: '<b style="color: #008000; font-size: 1.1rem;">7. Resultados y Descarga</b><br/><br/>¡Aquí están tus datos! Usa el botón verde para descargar el reporte.',
          position: window.innerWidth < 768 ? 'top' : 'left',
          tooltipClass: 'custom-tooltip-style step-left-forced',
          disableInteraction: false,
        }
      ]
    });

    // Lógica Proactiva (Fase Búsqueda + Validaciones v25)
    let searchValidator = null;

    tour.onbeforechange(function (targetElement) {
      tour.refresh();
      const stepIndex = tour._currentStep;
      const targetId = targetElement ? targetElement.getAttribute('id') : null;

      // Limpiar validadores previos
      if (searchValidator) clearInterval(searchValidator);

      if (stepIndex === 0) {
        setTimeout(() => {
          const selectContainer = document.querySelector('#tour-multi-select');
          if (selectContainer && selectContainer.innerText.length < 30) {
            const input = selectContainer.querySelector('input');
            if (input) {
              input.focus();
              const down = new KeyboardEvent('keydown', { key: 'ArrowDown', bubbles: true });
              const enter = new KeyboardEvent('keydown', { key: 'Enter', bubbles: true });
              input.dispatchEvent(down);
              setTimeout(() => input.dispatchEvent(enter), 150);
            }
          }
        }, 200);
      }

      // LÓGICA DE VALIDACIÓN UNIVERSAL (v25)
      const validatorIds = ['tour-multi-select', 'tour-anio-desde', 'tour-anio-hasta', 'tour-btn-buscar'];
      if (validatorIds.includes(targetId)) {
        searchValidator = setInterval(() => {
          const nextBtn = document.querySelector('.introjs-nextbutton');
          const validationMsg = document.querySelector('.tour-validation-msg');
          const container = document.getElementById(targetId);

          let isValid = false;

          switch (targetId) {
            case 'tour-multi-select':
              // Verificar si react-select tiene valores seleccionados (multi)
              isValid = container ? container.querySelectorAll('.select__multi-value').length > 0 : false;
              break;
            case 'tour-anio-desde':
            case 'tour-anio-hasta':
              // Verificar si react-select tiene valor (single)
              isValid = container ? container.querySelectorAll('.select__single-value').length > 0 : false;
              break;
            case 'tour-btn-buscar':
              // Verificar si ya existen resultados en el contenedor (Tabla de datos)
              const resultsContainer = document.getElementById('tour-resultados-container');
              isValid = resultsContainer ? resultsContainer.querySelector('.table') !== null : false;
              break;
            default:
              isValid = true;
          }

          if (nextBtn) {
            if (!isValid) {
              nextBtn.style.opacity = '0.4';
              nextBtn.style.pointerEvents = 'none';
              if (validationMsg) validationMsg.style.display = 'block';
            } else {
              nextBtn.style.opacity = '1';
              nextBtn.style.pointerEvents = 'auto';
              if (validationMsg) validationMsg.style.display = 'none';
            }
          }
        }, 500);
      }

      if (stepIndex >= 4) {
        return new Promise((resolve) => {
          let attempts = 0;
          const timer = setInterval(() => {
            attempts++;
            const selector = stepIndex === 4 ? '#tour-filtros-laterales' : '#tour-resultados-container';
            const el = document.querySelector(selector);
            // Esperar a que el elemento exista y tenga altura (que no sea un placeholder vacío)
            if ((el && el.offsetHeight > 50) || attempts > 30) {
              clearInterval(timer);
              setTimeout(() => {
                tour.refresh();
                resolve();
              }, 100);
            }
          }, 300);
        });
      }
      return Promise.resolve();
    });

    tour.oncomplete(() => {
      if (searchValidator) clearInterval(searchValidator);
      isStartedRef.current = false;
      localStorage.setItem('ifop_tour_v24', 'true');
      if (onExit) onExit();
    });

    tour.onexit(() => {
      if (searchValidator) clearInterval(searchValidator);
      isStartedRef.current = false;
      if (onExit) onExit();
    });

    tour.start();
    isStartedRef.current = true;
  };

  // 3. MANEJADORES DEL MODAL DE BIENVENIDA
  const handleSkipWelcome = () => {
    setShowWelcome(false);
    localStorage.setItem('ifop_tour_v24', 'true');
    if (onExit) onExit();
  };

  if (!showWelcome && !isStartedRef.current) return null;

  return (
    <>
      {showWelcome && (
        <div className="welcome-modal-overlay">
          <div className="welcome-modal-card">
            <div className="welcome-modal-header">
              <h2>{title}</h2>
            </div>
            <div className="welcome-modal-body">
              <p>¿Te gustaría realizar un breve recorrido guiado por las funciones principales?</p>
            </div>
            <div className="welcome-modal-footer">
              <button className="btn-start-tour" onClick={startTour}>
                Iniciar Recorrido
              </button>
              <button className="btn-skip-tour" onClick={handleSkipWelcome}>
                Quizás más tarde
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TourBuscador;
